/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_DeletedInputs */

const en_admin_categories_deleted = /** @type {(inputs: Admin_Categories_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category deleted`)
};

/**
* | output |
* | --- |
* | "Category deleted" |
*
* @param {Admin_Categories_DeletedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_categories_deleted = /** @type {((inputs?: Admin_Categories_DeletedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_DeletedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_categories_deleted(inputs)
});
export { admin_categories_deleted as "admin.categories.deleted" }